import React from 'react';
import { useTranslator, formatMeasurementUnit } from '@front-activerse/common-components';
import { Table, Alert } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { ICurrentMeasurement, IMeasurementObject } from '../../types';

interface ICurrrntMeasurementsContainerProps {
  currentMeasurements: ICurrentMeasurement;
  pathsMeasurementEdit: string;
  availableMeasurements: string[][];
}

const CurrentMeasurementsContainer: React.FC<ICurrrntMeasurementsContainerProps> = ({
  currentMeasurements,
  availableMeasurements,
  pathsMeasurementEdit,
}) => {
  const { t } = useTranslator();
  const navigate = useNavigate();

  const measurementArray = () => {
    const measurementsArray: IMeasurementObject[] = [];

    availableMeasurements.flat().forEach((type) => {
      if (currentMeasurements[type as keyof ICurrentMeasurement]) {
        measurementsArray.push({
          ...currentMeasurements[type as keyof ICurrentMeasurement],
          name: type,
        });
      }
    });

    return measurementsArray;
  };

  const renderChange = (change: number | undefined, unit: string | undefined) => {
    if (change && change < 0) {
      return (
        <span className="positive-change">
          {change} {unit}
        </span>
      );
    } else if (change === 0) {
      return <span className="neutral-change">-</span>;
    } else if (change && change > 0) {
      return (
        <span className="negative-change">
          +{change} {unit}
        </span>
      );
    }
  };

  const currentMeasurementsArray = measurementArray();

  return (
    <div>
      {currentMeasurementsArray.length > 0 ? (
        <div className="pt-l">
          <h2 className="title-medium semi-bold mb-m">
            {t('measurements.lastMeasurements.title')}
          </h2>
          <div className="white-box mb-xl">
            <Table>
              <tbody>
                {currentMeasurementsArray.map((measurement) => (
                  <tr
                    key={measurement.name}
                    onClick={
                      measurement.date
                        ? () =>
                            navigate(`${pathsMeasurementEdit.split('/:')[0]}/${measurement.date}`)
                        : undefined
                    }
                    className={measurement.date ? 'cursor-pointer' : ''}
                  >
                    <th>{t(`measurements.${measurement.name}`)}</th>
                    {measurement.value ? (
                      <>
                        <td>
                          <span className="featured">
                            {measurement.value} {formatMeasurementUnit(measurement.unit)}
                          </span>
                        </td>
                        <td className="text-end">
                          {renderChange(
                            measurement.change,
                            formatMeasurementUnit(measurement.unit)
                          )}
                        </td>
                      </>
                    ) : (
                      <td colSpan={2} className="text-end">
                        {t('no-data')}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : (
        <div className="d-none d-md-block pt-l">
          <h2 className="title-medium semi-bold mb-m">
            {t('measurements.lastMeasurements.title')}
          </h2>
          <Alert color="warning" className="mb-0">
            <p className="small">{t('measurements.noLastMeasurementAvailable')}</p>
          </Alert>
        </div>
      )}
    </div>
  );
};

export default CurrentMeasurementsContainer;
